Namespace 'Common'

class Common.DatetimeView extends Backbone.View
  template: JST["backbone/templates/common/datetime"]

  events:
    'click span': '_toggleDatepicker'
    'change .datefield': '_update'
    'change .timefield': '_update'
    'click .icon-remove': '_clearValues'

  initialize: (@options = {}) ->
    @required = @options.required
    @clearButton = !!@options.clearButton
    @startDate = @options.startDate # optional lower bound for the datepicker
    @valueHolder = @options.valueHolder # optional external hidden field
    if @valueHolder and $(@valueHolder).val()
      @datetime = new Date($(@valueHolder).val())
    else
      @datetime = @options.defaultDate || undefined
    minutesStep = @options.minutesStep || 30
    @_ceilingTime(minutesStep)


  render:()->
    hourSelected = if @datetime then @datetime.format('HH:mm') else ''
    @$el.html(@template({required: @required, hours: @_hours(hourSelected), clearButton: @clearButton}))

    if @datetime
      @_datefield().val(@datetime.format('DD/MM/YYYY'))

    datepickerOptions =
      format: 'dd/mm/yyyy'
      todayBtn: 'linked'
      autoclose: true
    datepickerOptions.startDate = @startDate if @startDate
    @_datefield().datepicker(datepickerOptions)

    if @datetime == undefined
      @_clearValues()

    @

  disable: (clearValues = true) ->
    @_datefield().get(0).disabled = true;
    @_timefield().get(0).disabled = true;
    @$el.find('span').addClass("disabled");
    @_clearValues() if clearValues

  enable:->
    @_datefield().get(0).disabled = false;
    @_timefield().get(0).disabled = false;
    @$el.find('span').removeClass("disabled");

  setDate: (dateTime)->
    @datetime = dateTime
    @render()

  getDate:->
    new Date(@datetime.setHours(0,0,0,0)) if @datetime

  getDatetime:->
    @datetime

  _datefield:->
    @$el.find('.datefield')

  _timefield:->
    @$el.find('.timefield')

  _getDatetimeStr:->
    @_datefield().val() + ' ' + @_timefield().val()

  _clearValues:->
    @_datefield().val('')
    @_timefield().val('')
    @_timefield().prop('disabled', true)
    $(@valueHolder).val('')
    @datetime = undefined

  _hours:(hourSelected)->
    hours = []
    base = new Date().setHours(0,0,0,0)
    for i in [0..47]
      h = new Date(base + i * 30 * 60 * 1000)
      hour = h.format('HH:mm')
      hours.push({hour: hour, selected: hour == hourSelected})
    hours

  _toggleDatepicker:->
    if !@_datefield().is(':disabled')
      @_datefield().datepicker('show')

  _update:->
    if @_datefield().val()
      @datetime = new Date(@_getDatetimeStr().replace(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/, '$3-$2-$1T$4:$5'))
      @_timefield().prop('disabled', false)
      if !@_timefield().val()
        @_timefield().val('00:00')
    else
      @datetime = undefined
      @_timefield().val('')
      @_timefield().prop('disabled', true)

    if @valueHolder
      if @datetime
        $(@valueHolder).val(@_getDatetimeStr())
      else
        $(@valueHolder).val('')

    @trigger('change')

  _ceilingTime:(minutesStep)->
    if @datetime
      @datetime = new Date(Math.ceil(@datetime / 1000 / 60 / minutesStep) * minutesStep * 60 * 1000)
